// wayai unbind — clear the per-worktree hub binding.
// (Also reachable as `wayai unlock`, the deprecated pre-rename alias.)

import { clearBinding, readBinding } from '../lib/hub-binding.js';

export async function unbindCommand(_args: string[]): Promise<void> {
  const previous = readBinding();
  if (!previous) {
    console.log('No worktree binding to clear.');
    return;
  }

  // ENOENT between read and unlink is fine — binding is already gone.
  clearBinding();
  console.log(`Worktree unbound (was: ${previous}).`);
}
